import { IChatFilesResponseSchema } from '../repositories/chats/entities/file/ChatFilesResponseSchema';
import { TGetLatestChatFilesResponse, fetchGetLatestChatFiles } from '../repositories/chats/v1/get-latest-chat-files';
import { TContext } from '../types/context';

type TFetchGetLatestChatFilesRequest = {
  chatId: string;
  offset: number;
};

type TFetchGetLatestChatFilesParams = {
  parameters: TFetchGetLatestChatFilesRequest;
  cookies?: string;
};

export async function fetchChatImages(
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchGetLatestChatFilesParams,
) {
  try {
    const { response, statusCode }: TGetLatestChatFilesResponse = await fetchGetLatestChatFiles({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      logger.warning('Код ответа не 200', {
        message: 'Не удалось получить файлы для чата',
        domain: 'src/shared/services/fetchChatImages.ts [fetchChatImages]',
        statusCode,
        messsage: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });

      return null;
    }

    return response as IChatFilesResponseSchema;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/fetchChatImages.ts [fetchChatImages]',
      description: 'Ошибка при получении файлов для чата',
    });

    return null;
  }
}
